exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".permalink-modal .install-button {\n  margin: 0.5rem 0 1rem 0;\n  display: inline-block; }\n\n.permalink-modal .well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: whitesmoke;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05); }\n\n.permalink-modal .text-center {\n  text-align: center; }\n\n.permalink-modal .subheader {\n  margin-bottom: 10px; }\n", ""]);

// exports
